import { Component, OnInit, isDevMode, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { LogService } from './core/service/log/logservice';
import { offlineService } from './core/service/notification/Notification.service';
import { DisableRightClickService } from './core/service/RightclickService.ts/rightclickdisable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Marine Store Guide';
  jsonData: any;

  @HostListener('document:keydown', ['$event'])
  handleDeleteKeyboardEvent(event: KeyboardEvent) {
    // if (event.keyCode == 123) {
    //   return false;
    // }
    if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
      return false; //Prevent from ctrl+shift+i
    }
    if (event.ctrlKey && event.keyCode == 67) {
      return false;
    }
    if (event.ctrlKey && event.keyCode == 45) {
      return false;
    }
  }

  constructor(
    private offlineNotify: offlineService,
    private messageService: MessageService,
    private rightClickDisable: DisableRightClickService,
    private router: Router,
    private JsonService: LogService
  ) {}

  ngOnInit() {
    this.getJson();
    this.rightClickDisable.disableRightClick();
    if (isDevMode()) {
      console.log('Development!');
    } else {
      console.log('Production!');
    }
    this.offlineNotify.setupSocketConnection();
    this.onReload();
    this.listener();
  }

  onReload() {
    let id = {
      id: JSON.parse(sessionStorage.getItem('reconnectId') || '{}'),
    };
    this.offlineNotify.emit('reconnect', id);
  }

  listener() {
    this.offlineNotify.listen('planChange').subscribe((data: any) => {
      console.log(data);
      if (data['msg'] == 'true') {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'License Plan has been changed',
          life: 1000,
        });
        sessionStorage.clear();
        sessionStorage.clear();
      }
      setTimeout(() => {
        this.router.navigateByUrl('/login');
      }, 500);
    });
  }
  getJson() {
    this.JsonService.getData().subscribe((data: any): void => {
      console.info(data);
      this.jsonData = data;
    });
  }
}
